import { css } from '@emotion/react';
import {
  Accordion,
  Box,
  COLOR_PALETTE,
  Stack,
  Title,
  desktopFirstMediaQuery,
} from '@inflearn/ds-react-next';
import { Trans, useTranslation } from 'next-i18next';
import Link from 'next/link';
import { generateSiteURL } from '../../../utils/url';

const FaqSection = () => {
  const { t } = useTranslation();

  const FAQ_ITEMS = [
    {
      question: t('open.knowledge.faq.q1'),
      answer: () => {
        return (
          <Trans
            i18nKey="open.knowledge.faq.a1"
            components={{
              a: (
                <Link
                  css={{ textDecoration: 'underline' }}
                  target="_blank"
                  href={generateSiteURL(
                    '/course/%EC%A7%80%EC%8B%9D%EA%B3%B5%EC%9C%A0%EC%9E%90-%EA%B0%95%EC%9D%98-%EB%A7%8C%EB%93%A4%EA%B8%B0',
                    { useLang: true, baseURL: 'https://www.inflearn.com' },
                  )}
                />
              ),
            }}
          />
        );
      },
    },
    {
      question: t('open.knowledge.faq.q2'),
      answer: () => t('open.knowledge.faq.a2'),
    },
    {
      question: t('open.knowledge.faq.q3'),
      answer: () => t('open.knowledge.faq.a3'),
    },
    {
      question: t('open.knowledge.faq.q4'),
      answer: () => t('open.knowledge.faq.a4'),
    },
    {
      question: t('open.knowledge.faq.q5'),
      answer: () => t('open.knowledge.faq.a5'),
    },
  ];

  return (
    <Box component="section" css={styleSection}>
      <Stack
        gap={40}
        align="center"
        styles={{
          root: styleContents,
        }}
      >
        <Title
          order={2}
          ta="center"
          c="white"
          fz={34}
          lh={1.3}
          styles={{
            root: styleSectionTitle,
          }}
        >
          {t('open.knowledge.faq.title')}
        </Title>
        <Accordion
          variant="separated"
          defaultValue="0"
          chevronPosition="right"
          color="dark.4"
          styles={{
            item: {
              backgroundColor: COLOR_PALETTE.dark[4],
              border: 'none',
              borderRadius: 12,
              '&&': {
                marginTop: 8,
              },
              '&[data-active]': {
                backgroundColor: COLOR_PALETTE.dark[4],
              },
            },

            control: {
              fontSize: 16,
              lineHeight: 1.5,
              padding: '4px 20px',
              span: {
                color: '#ffffff',
                fontWeight: 700,
              },
              '&:hover': {
                backgroundColor: 'transparent',
              },
            },

            chevron: {
              color: '#ffffff',
            },

            content: {
              color: '#c1c2c5',
              fontSize: 16,
              fontWeight: 400,
              lineHeight: 1.7,
              padding: '0 24px 16px',
            },

            root: styleAccordion,
          }}
        >
          {FAQ_ITEMS.map((item, index) => (
            <Accordion.Item value={String(index)} key={item.question}>
              <Accordion.Control>{item.question}</Accordion.Control>
              <Accordion.Panel>{item.answer()}</Accordion.Panel>
            </Accordion.Item>
          ))}
        </Accordion>
      </Stack>
    </Box>
  );
};

export default FaqSection;

const styleSection = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: '#25262b',
  padding: '100px 32px',
  width: '100%',
  [desktopFirstMediaQuery.mobile]: {
    padding: '80px 16px',
  },
});

const styleContents = css({
  maxWidth: 800,
  width: '100%',
});

const styleSectionTitle = css({
  fontSize: 34,
  lineHeight: 1.3,
  [desktopFirstMediaQuery.mobile]: {
    fontSize: 24,
  },
});

const styleAccordion = css({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
});
